import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgCat = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 47 52", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.55,
      d: "M44.615 31.93c-.778-.874-2.182-.83-2.965.039-2.18 2.42-1.06 8.195-4.906 9.714-.767.303-1.583.567-2.417.812-.968-9.82-4.784-16.589-11.76-19.96 1.575-1.904 2.55-4.268 2.66-6.843l.014.021V2.681c0-1.461-1.758-2.228-2.85-1.241l-3.68 3.325a13.161 13.161 0 0 0-6.09-1.477c-2.209 0-4.285.537-6.09 1.48L2.85 1.441C1.757.456 0 1.22 0 2.681v13.027l.014-.02c.138 3.267 1.671 6.196 4.053 8.271l-1.456 2.19a3.842 3.842 0 0 0-.642 2.126v19.792c0 1.628 1.336 2.947 2.984 2.947h4.309c1.647 0 2.984-1.32 2.984-2.947 0 1.628 1.336 2.947 2.984 2.947h3.769c1.648 0 2.984-1.32 2.984-2.947 0 1.628 1.336 2.947 2.984 2.947h9.545C47.027 49.8 47.867 35.56 44.625 31.93h-.01Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.55,
      d: "M12.62 27.119c6.97 0 12.621-5.335 12.621-11.916s-5.65-11.916-12.62-11.916C5.65 3.287 0 8.622 0 15.203s5.65 11.916 12.62 11.916Z",
      fill: "#65BFF1"
    }
  ),
  /* @__PURE__ */ jsx("g", { opacity: 0.85, fill: "#65BFF1", children: /* @__PURE__ */ jsx("path", { d: "M8.868 15.146c.179-1.107-.47-2.13-1.45-2.286-.981-.155-1.922.617-2.101 1.725-.18 1.107.47 2.13 1.45 2.286.981.155 1.921-.617 2.1-1.725ZM18.589 16.868c.98-.155 1.63-1.179 1.45-2.286-.179-1.108-1.12-1.88-2.1-1.725-.98.155-1.63 1.179-1.45 2.286.18 1.107 1.12 1.88 2.1 1.725Z" }) }),
  /* @__PURE__ */ jsx(
    "path",
    {
      opacity: 0.75,
      d: "M13.013 19.529c.708-.39 1.31-.869 1.79-1.45.348-.419.076-1.049-.47-1.097a3.639 3.639 0 0 0-1.168.08 1.965 1.965 0 0 1-.928 0 3.328 3.328 0 0 0-1.23-.066c-.537.06-.802.683-.458 1.095a6.206 6.206 0 0 0 1.782 1.438c.21.116.471.116.682 0Z",
      fill: "#65BFF1"
    }
  )
] });
const ForwardRef = forwardRef(SvgCat);
export {
  ForwardRef as default
};
